<template>
	<div class="inner-page-container">
		<div v-if="item">
			<InnerHeroSection :type="type" :item="item" :id="id" />
			<div class="main-content-wrapper" :v-focus-section="isNativeDevice">
				<MainContentWrapper @update_season="handleSeasonUpdate" :item="item" :type="type" :id="id" />
				<InnerDescriptionSection :type="type" :item="item" :id="id" />
				<SameCategory :type="type" :item="item" :id="id" />
				<InnerEpisodesSection
					v-if="type === 'series'"
					:type="type"
					:item="item"
					:id="id"
					:current-season="selectedSeason"
				/>
			</div>
		</div>
		<pulse-loader v-else :loading="true" :color="'white'" :size="'12px'"></pulse-loader>
	</div>
</template>

<script lang="ts" setup>
	import { useRoute } from "vue-router"
	import { onMounted, computed, ref } from "vue"
	import { isNativeDevice } from "../helper"
	import InnerHeroSection from "../components/InnerHeroSection.vue"
	import InnerDescriptionSection from "../components/InnerDescriptionSection.vue"
	import SameCategory from "../components/SameCategory.vue"
	import InnerEpisodesSection from "../components/series/InnerEpisodesSection.vue"
	import { useMovieStore } from "../stores/movies"
	import { useSeriesStore } from "../stores/series"
	import api from "../composables/useApi"
	import { useI18n } from "vue-i18n"
	import { useTaxonomyStore } from "../stores/taxonomies"
	import MainContentWrapper from "../components/MainContentWrapper.vue"
	import { useUserStore } from "../stores/user"
	import { useRouter } from "vue-router"
	import { useTitle } from "@vueuse/core"
	const userStore = useUserStore()
	const taxonomyStore = useTaxonomyStore()
	const router = useRouter()
	const movieStore = useMovieStore()
	const seriesStore = useSeriesStore()
	const route = useRoute()
	const { locale } = useI18n()

	// normalize id to number once
	const id = Number(route.params.id)
	const type = route.name === "InnerMovie" ? "movie" : "series"
	const fetchedItem = ref<any>(null)
	const loading = ref(false)
	// taxonomyStore.getFeatures()
	// taxonomyStore.getCasting()
	// taxonomyStore.getType()
	taxonomyStore.getQuality()
	taxonomyStore.getAppropriateness()
	const selectedSeason = ref(1)
	const handleSeasonUpdate = (newSeason) => {
		selectedSeason.value = newSeason ? Number(newSeason) : 1
	}

	// Search through the new store structure (array of {category, data})
	const storeItem = computed(() => {
		if (type === "movie") {
			// Search through all movie categories
			for (const categoryGroup of movieStore.state.movies as any[]) {
				if (categoryGroup.data && Array.isArray(categoryGroup.data)) {
					const found = categoryGroup.data.find((m: any) => m.drupal_internal__nid === id)
					if (found) return found
				}
			}
		} else if (type === "series") {
			// Search through all series categories
			for (const categoryGroup of seriesStore.state.series as any[]) {
				if (categoryGroup.data && Array.isArray(categoryGroup.data)) {
					const found = categoryGroup.data.find((s: any) => s.drupal_internal__nid === id)
					if (found) return found
				}
			}
		}
		return null
	})

	// Combined item: prefer store, fallback to fetched
	const item = computed(() => {
		const item = storeItem.value || fetchedItem.value
		if (item) {
			useTitle(`${item?.title} | Valor Movies` || "Valor Movies")
		}

		return item
	})

	// Fetch item from API if not in store
	const fetchItem = async () => {
		if (storeItem.value || loading.value) return

		loading.value = true
		try {
			const endpoint = type === "movie" ? "node/movie" : "node/series"
			const includeParams = type === "series" ? ",field_image" : ""
			const response = await api.get(
				`${locale.value}/jsonapi/${endpoint}?jsonapi_include=1&include=field_trailer_file,field_image,field_category,field_type,field_features,field_cast,field_hero_image${includeParams}`,
				{
					params: {
						"filter[drupal_internal__nid]": id,
						"filter[langcode]": locale.value,
						"filter[status]": 1,
					},
				}
			)

			if (response.data.data && response.data.data.length > 0) {
				fetchedItem.value = response.data.data[0]
			} else {
				console.warn(`${type} with id ${id} not found.`)
				router.replace({ name: "NotFound" })
			}
		} catch (error) {
			console.error(`Failed to fetch ${type} with id ${id}:`, error)
		} finally {
			loading.value = false
		}
	}

	onMounted(async () => {
		window.scrollTo(0, 0)
		await fetchItem()
	})
</script>

<style lang="scss" scoped>
	.inner-page-container {
		min-height: 100vh;
		position: relative;
	}

	.v-spinner {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.main-content-wrapper {
		max-width: 870px;
		margin: 0 auto;
		width: 100%;
		// margin-top: -180px;
		z-index: 2;
		position: relative;
		margin-top: -18vw;
		z-index: 9;
		position: relative;
		opacity: 1;

		@include br.respond-to(br.$laptop-large) {
			margin-top: -15vw;
		}

		@include br.respond-to(br.$mobile-large) {
			margin-top: -80px;
		}

		@include br.tablet-down {
			padding: 0;
		}
	}
</style>
